import {
  RegistrarInstitucion,
  TablaInstituciones,
  useInstituciones,
  usuariosPorInstitucion,
} from "@/features/instituciones";
import { useUsuarios } from "@/features/usuarios";
import { t } from "@/shared/i18n";
import { EncabezadoPagina, Tarjeta, Vacio } from "@/shared/ui";
import { SegunConsulta, useTitulo } from "./comun";
import estilos from "./Paginas.module.css";

const i = t.instituciones;

export function Instituciones() {
  const consulta = useInstituciones();
  const usuarios = useUsuarios();
  useTitulo(i.titulo);
  const lista = consulta.data ?? [];

  return (
    <div className={estilos.pila}>
      <EncabezadoPagina
        titulo={i.titulo}
        subtitulo={i.subtitulo}
        lateral={<RegistrarInstitucion existentes={lista} />}
      />
      <SegunConsulta consulta={consulta}>
        {() => (
          <Tarjeta>
            {lista.length === 0 ? (
              <Vacio titulo={i.vacioTitulo}>{i.vacioTexto}</Vacio>
            ) : (
              <TablaInstituciones instituciones={lista} usuariosPor={usuariosPorInstitucion(usuarios.data ?? [])} />
            )}
          </Tarjeta>
        )}
      </SegunConsulta>
    </div>
  );
}
